import { forwardRef, JSX } from 'react';
import { Input, InputProps, Field, InputGroup, Flex } from '@chakra-ui/react';
import { PasswordInput } from '../ui/password-input';

interface InputFieldProps extends InputProps {
  error: string | undefined;
  width: string;
  icon?: JSX.Element;
  type?: string;
  text?: string;
}

const FormInput = forwardRef<HTMLInputElement, InputFieldProps>(
  ({ width, error, icon, text, type = 'text', ...rest }, ref) => {
    return (
      <Field.Root
        pos="relative"
        w={width}
        invalid={!!error}
        display="flex"
        flexDir="column"
      >
        {text && (
          <Field.Label mb="2" fontSize="14px" fontWeight="500">
            {text}
          </Field.Label>
        )}
        <InputGroup width="full" flex="1" startElement={icon || undefined}>
          {type === 'password' ? (
            <PasswordInput
              fontSize="16px"
              ref={ref}
              h="44px"
              borderRadius="full"
              border="1.5px solid"
              borderColor={{ base: 'rgba(0,176,202,0.2)', _dark: 'rgba(0,176,202,0.15)' }}
              width="full"
              bg={{ base: '#FFFFFF', _dark: '#0D2035' }}
              color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
              _placeholder={{ color: 'rgba(0,0,0,0.35)', _dark: { color: 'rgba(255,255,255,0.35)' } }}
              _hover={{ borderColor: '#00B0CA', boxShadow: 'none' }}
              _focus={{ borderColor: '#00B0CA', boxShadow: '0 0 0 3px rgba(0,176,202,0.12)', outline: 'none' }}
              _active={{ boxShadow: 'none' }}
              _invalid={{ borderColor: 'red.400' }}
              {...rest}
            />
          ) : (
            <Input
              fontSize="16px"
              ref={ref}
              type={type}
              h="44px"
              borderRadius="full"
              border="1.5px solid"
              borderColor={{ base: 'rgba(0,176,202,0.2)', _dark: 'rgba(0,176,202,0.15)' }}
              width="full"
              bg={{ base: '#FFFFFF', _dark: '#0D2035' }}
              color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
              _placeholder={{ color: 'rgba(0,0,0,0.35)', _dark: { color: 'rgba(255,255,255,0.35)' } }}
              _hover={{ borderColor: '#00B0CA', boxShadow: 'none' }}
              _focus={{ borderColor: '#00B0CA', boxShadow: '0 0 0 3px rgba(0,176,202,0.12)', outline: 'none' }}
              _active={{ boxShadow: 'none' }}
              _invalid={{ borderColor: 'red.400' }}
              {...rest}
            />
          )}
        </InputGroup>
        {error && (
          <Flex align="center" ml="1">
            <Field.ErrorIcon w="3.5" h="3.5" mr="1" />
            <Field.ErrorText>{error}</Field.ErrorText>
          </Flex>
        )}
      </Field.Root>
    );
  },
);

FormInput.displayName = 'FormInput';

export default FormInput;
